/*
 * CarSelector Messages
 *
 * This contains all the text for the Car Selector container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.CarSelector';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the HomePage container!',
  },
  brands: {
    id: `${scope}.brands`,
    title: 'Marca',
    defaultMessage: 'Inizia a digitare o seleziona un brand',
  },
  models: {
    id: `${scope}.models`,
    title: 'Modello',
    defaultMessage: 'Inizia a digitare o seleziona un modello',
  },
  versions: {
    id: `${scope}.versions`,
    title: 'Allestimento',
    defaultMessage: 'Inizia a digitare o seleziona un allestimento',
  },
  images: {
    id: `${scope}.images`,
    title: 'Imagini',
    defaultMessage: "Gestisci le imagini dell'auto selezionata",
  },
  car: {
    id: `${scope}.car`,
    title: 'Automobile',
    defaultMessage: "L'automobile da te selezionata è: ",
  },
  newCar: {
    id: `${scope}.newCar`,
    title: 'Aggiungi allestimento non presente',
  },
  editCar: {
    id: `${scope}.editCar`,
    title: 'Modifica allestimento personalizzato',
  },
  showCar: {
    id: `${scope}.showCar`,
    title: 'Visualizza dettagli allestimento',
  },
});
